/* src/app/reports/revenue-report/revenue-report.component.css */
.toolbar {
  padding: 16px;
}
.create-button {
  margin-top: 12px;
}
/*# sourceMappingURL=revenue-report.component.css.map */
